<template>
  <div>
    <div class="wizard__header" v-html="this.fullHeader"></div>
    <div v-show="data.confirmationNumber">
      <div class="wizard__bell-curve">

        <!-- <img class="wizard__bell-curve__img" :src="`/images/wizard/bell-curves/${this.fileName}`" v-if="this.$parent.active" /> -->
        <svg width="772" height="275" viewBox="0 0 772 275" fill="none" xmlns="http://www.w3.org/2000/svg" id="bellcurve">
            <path d="M228 176.533C199.07 212 155 274.25 68 274.25H704C617 274.25 565.323 214 534.561 176.533C420 37 341 38 228 176.533Z" fill="url(#paint0_linear)"/>
            <path d="M68 274.25C155 274.25 199.07 212 228 176.533C341 38 420 37 534.561 176.533C565.323 214 617 274.25 704 274.25" stroke="#a4a4a4" fill="url(#paint0_linear)" stroke-width="4"/>
            <line y1="274.25" x2="772" y2="274.25" stroke="#a4a4a4" stroke-width="4"/>
            <path d="M382.75 72V274" stroke="#a4a4a4" stroke-width="2"/>
            <circle cx="190" cy="221" r="9.25" fill="white" stroke="#a4a4a4" stroke-width="4"/>
            <circle cx="562" cy="207" r="9.25" fill="white" stroke="#a4a4a4" stroke-width="4"/>
            <circle cx="383" cy="76" r="9.25" fill="white" stroke="#a4a4a4" stroke-width="4"/>
            <text fill="#73706e" xml:space="preserve" style="white-space: pre" font-family="brandon-grotesque" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="140.492" y="196.04">LOW</tspan></text>
            <text fill="#73706e" xml:space="preserve" style="white-space: pre" font-family="brandon-grotesque" font-size="22" font-weight="500" letter-spacing="0em"><tspan x="130" y="173.68">${{ estimatedLow }}&#10;</tspan></text>
            <text fill="#73706e" xml:space="preserve" style="white-space: pre" font-family="brandon-grotesque" font-size="30" font-weight="500" letter-spacing="0em"><tspan x="350" y="28.2">${{ estimatedMid }}&#10;</tspan></text>
            <text fill="#73706e" xml:space="preserve" style="white-space: pre" font-family="brandon-grotesque" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="351.758" y="51.04">AVERAGE</tspan></text>
            <text fill="#73706e" xml:space="preserve" style="white-space: pre" font-family="brandon-grotesque" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="594.227" y="196.04">HIGH</tspan></text>
            <text fill="#73706e" xml:space="preserve" style="white-space: pre" font-family="brandon-grotesque" font-size="22" font-weight="500" letter-spacing="0em"><tspan x="585" y="173.68">${{ estimatedHigh }}&#10;</tspan></text>
            <defs>
            <linearGradient id="paint0_linear" x1="386" y1="72.2578" x2="386" y2="274.25" gradientUnits="userSpaceOnUse">
                <stop stop-color="#ffffff" stop-opacity="0"/>
                <stop offset="5" stop-color="#95b9b9" stop-opacity="1"/>
            </linearGradient>
            </defs>
        </svg>
      </div>

      <ul class="wizard__nav" v-if="onPrevious">
        <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--previous" @click.prevent="onPrevious">Previous</a></li>
        <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--next" @click.prevent="nextClickHandler">Get a more Accurate Price</a></li>
      </ul>
    </div>

    <div v-show="!data.confirmationNumber">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { bedroomSizeValues} from '../classes/Globals';
  export default {
    props: {
      onResponse: {
        type: Function
      },

      onPrevious: {
        type: Function
      },

      data: {
        type: Object
      },

      header: {
        type: String
      }
    },

    data: () => ({

    }),

    computed: {
      fileName() {
        let numOfBedrooms = this.numOfBedrooms.replace(/\s+/g, '-').toLowerCase();;
        let typeOfMove = this.typeOfMove.replace(/\s+/g, '-').toLowerCase();;
        let packingType = this.packingType.replace(/\s+/g, '-').toLowerCase();;

        return `${numOfBedrooms}.png`
      },

      numOfBedrooms() {
        return this.data.size ? this.data.size : '-';
      },

      typeOfMove() {
        return this.data.distance ? this.data.distance.toLowerCase() : '-';
      },

      packingType() {
        return this.data.packing && this.data.packing == 'Yes' ? 'with packing' : 'self-packing';
      },

      fullHeader() {
        return `${this.header}<p>${this.numOfBedrooms}, ${this.typeOfMove} move, ${this.packingType}</p>`;
      },
      estimatedLow() {
          return this.data.size !== undefined ? bedroomSizeValues[this.data.size].low : 0;
      },
      estimatedMid() {
          return this.data.size !== undefined ? bedroomSizeValues[this.data.size].mid : 0;
      }, 
      estimatedHigh() {
          return this.data.size !== undefined ? bedroomSizeValues[this.data.size].high : 0;
      }
    },

    mounted() {},

    methods: {
      nextClickHandler() {
        this.onResponse({
          data: {
            estimatedTotal: `$${this.estimatedLow} to $${this.estimatedHigh}`
          },
          response: true
        });
      }
    }
  };
</script>
